import { ArrowBackIos, ChevronLeft } from '@mui/icons-material';
import { Box, Divider, Grid, Typography } from '@mui/material';
import React, { Component } from 'react';
class NavbarMobile extends Component {
    state = {  } 
    render() { 
        return (
            <Box>
                <Box sx={{margin: "10px", pl: "5px"}} >
                    <Grid container spacing={1}>
                        {
                                this.props.showBackButton && (
                                    <Grid xs={1} item>
                                        <ArrowBackIos onClick={this.props.onClose} className="" style={{cursor: "pointer"}}/>
                                    </Grid>
                                )
                        }
                        <Grid xs={11} item>
                            <Typography sx={{fontWeight: "bold"}} variant="h6" gutterBottom component="div">
                                {this.props.title}
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                <Divider />
            </Box>
        );
    }
}
 
export default NavbarMobile;